import { render, staticRenderFns } from "./ClassStudent.vue?vue&type=template&id=068c51e6&scoped=true&"
import script from "./ClassStudent.vue?vue&type=script&lang=js&"
export * from "./ClassStudent.vue?vue&type=script&lang=js&"
import style0 from "./ClassStudent.vue?vue&type=style&index=0&id=068c51e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068c51e6",
  null
  
)

export default component.exports